/** Default BR geo IDs — aligned with `apps/api/src/seeds/dev-geo-ids.ts` (local dev). */

export const DEFAULT_BRAZIL_GEO = {
  countryId: 'cccccccc-cccc-4ccc-8ccc-cccccccc0001',
  stateId: 'cccccccc-cccc-4ccc-8ccc-cccccccc1026',
  cityId: 'cccccccc-cccc-4ccc-8ccc-cccccccc2026',
} as const;
